import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";

  interface Option {
    label: string;
    value: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownWithCheckboxes',
  props: {
    options: {},
    placement: {}
  },
  emits: ["change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;

  const showDropDown = ref(false);
  const areAllChecked = ref(false);
  const selectedOptions = ref<string[]>([]);

  const selectedLabel = computed(() => {
    if (selectedOptions.value.length === 0) return "Sales tools";

    if (selectedOptions.value.length === 1)
      return (
        props.options.find((opt) => opt.value === selectedOptions.value[0])
          ?.label ?? "Sales tools"
      );

    if (selectedOptions.value.length === props.options.length)
      return "All Selected";

    return `${selectedOptions.value.length} Selected`;
  });

  const toggleDropdown = () => {
    showDropDown.value = !showDropDown.value;
  };

  const closeDropdown = () => {
    showDropDown.value = false;
  };

  const updateStatus = () => {
    areAllChecked.value = selectedOptions.value.length === props.options.length;
  };

  const toggleCheckAll = () => {
    if (areAllChecked.value) {
      selectedOptions.value = [];
    } else {
      selectedOptions.value = props.options.map((option) => option.value);
    }

    updateStatus();
    emits("change", selectedOptions.value);
  };

  const toggleOption = (optionValue: string) => {
    const index = selectedOptions.value.indexOf(optionValue);

    if (index >= 0) {
      selectedOptions.value.splice(index, 1);
    } else {
      selectedOptions.value.push(optionValue);
    }

    updateStatus();
    emits("change", selectedOptions.value);
  };

  watch(selectedOptions, () => {
    emits("change", selectedOptions.value);
  });

const __returned__ = { props, emits, showDropDown, areAllChecked, selectedOptions, selectedLabel, toggleDropdown, closeDropdown, updateStatus, toggleCheckAll, toggleOption, ref, computed, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})